import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'craft-line-loading',
  templateUrl: './craft-line-loading.component.html',
  styleUrls: ['./craft-line-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CraftLineLoadingComponent {}
